import React from 'react';
import PropTypes from 'prop-types';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import { numberWithSpaces } from 'shared/helpers/common';
import { numberWithSpacesRegexp } from 'shared/constants/regexp';

export default class NumberInput extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    autoFocus: PropTypes.bool,
    separateThousands: PropTypes.bool,
  };
  static defaultProps = {
    onChange: () => {},
    value: '',
    autoFocus: false,
    separateThousands: true,
  };

  componentDidMount() {
    if (this.inputRef && this.props.autoFocus) {
      this.inputRef.focus();
      this.updateSelection();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.updateSelection();
    }
  }

  setInputRef = inputRef => {
    this.inputRef = inputRef;
  };

  updateSelection = () => {
    const { length } = this.inputRef.value;

    setTimeout(() => {
      if (this.inputRef && this.inputRef.setSelectionRange && this.inputRef.type === 'text') {
        this.inputRef.setSelectionRange(length, length);
      }
    }, 0);
  };

  handleChange = value => this.props.onChange(value.replace(/\s/g, ''));

  render() {
    const { value, separateThousands, ...props } = this.props;
    const safeValue = value || '';

    return (
      <RegexpInput
        {...props}
        pattern={numberWithSpacesRegexp}
        value={separateThousands ? numberWithSpaces(safeValue) : safeValue}
        onChange={this.handleChange}
        inputRef={this.setInputRef}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/NumberInput/NumberInput.js